import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceInput, SelectInput, required as raRequired } from "react-admin";
import { CampaignSubTypeLabels } from "utils/constants";

const ChildCampaignInput = ({ childCampaignSubTypeId, readOnly, required }) => {
  const inputLabel = CampaignSubTypeLabels[childCampaignSubTypeId];

  return (
    <ReferenceInput
      label={inputLabel || "Кампания"}
      source="childCampaignId"
      reference={candidateRequests.getCampaignsSelect()}
      filter={{ subType: childCampaignSubTypeId }}
    >
      <SelectInput
        label={inputLabel || "Кампания"}
        optionText="nameBg"
        validate={required ? [raRequired()] : []}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default ChildCampaignInput;
